import * as L from 'leaflet';
import Mustache from 'mustache';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import { svgToGeoJson } from './svgtogeojson';

export default class Floorplan {
	constructor() {
		this.floorplan = document.querySelector('[data-floorplan="element"]');

		if (themeVars.hasOwnProperty('floorplan') === false || this.floorplan === null) {
			return;
		}

		this.state = this.getDefaultState();
		this.svg = document.querySelector('[data-floorplan-svg="element"] > svg');

		const ratio = window.innerWidth < 992 ? window.innerWidth / 250 : 2;

		this.width = parseInt(this.svg.getAttribute('width')) * ratio;
		this.height = parseInt(this.svg.getAttribute('height')) * ratio;

		this.apartments = themeVars.floorplan.hasOwnProperty('apartments') ? themeVars.floorplan.apartments : {};

		this.events = {};
		this.jsonLayer;

		document.body.scrollTop = 0;
		document.documentElement.scrollTop = 0;
		disableBodyScroll(this.svg);

		this.initMap();
	}

	getDefaultState() {
		const defaultState = {
			view: 'visual',
			filter: {
				open: false,
				active: {},
			},
			sort: {
				attribute: 'number',
				direction: 'asc',
			},
		};

		return defaultState;
	}

	initMap() {
		this.canvas = this.floorplan.querySelector('[data-floorplan-visual="element"]');
		this.bounds = [
			[0, 0],
			[this.height, this.width],
		];

		console.log(this.canvas);

		this.map = L.map(this.canvas, {
			crs: L.CRS.Simple,
			maxBounds: this.bounds,
			maxBoundsViscosity: 1.0,
			maxZoom: 1,
			zoom: 1,
			zoomControl: false,
			zoomDelta: 0.25,
			zoomSnap: 0.25,
			bounceAtZoomLimits: false,
			attributionControl: false,
			padding: [100, 100],
		});

		this.map.getRenderer(this.map).options.padding = 100;

		const image = L.imageOverlay(this.canvas.getAttribute('data-url'), this.bounds, {
			interactive: false,
		}).addTo(this.map);

		const zoom = L.control.zoom({ position: 'bottomright' }).addTo(this.map);

		this.map.fitBounds(this.bounds);
		this.addMapLayer();

		this.floorplan.addEventListener('filtersChanged', (e) => {
			this.addMapLayer();
		});
	}

	addMapLayer() {
		if (typeof this.jsonLayer !== 'undefined' && this.map.hasLayer(this.jsonLayer)) {
			this.map.removeLayer(this.jsonLayer);
		}

		const geoJson = svgToGeoJson(
			[
				[this.height, this.width],
				[0, 0],
			],
			this.svg,
			5,
			['id'],
		);

		this.jsonLayer = L.geoJson(geoJson, {
			style: (feature) => {
				const isAvailable = this.isAvailable(feature);

				return {
					fillColor: '#df2b27',
					color: '#df2b27',
					fillOpacity: isAvailable === true ? 0 : 0.5,
					opacity: 0,
					weight: 2,
				};
			},
			onEachFeature: this.eachFeature.bind(this),
		}).addTo(this.map);
	}

	isAvailable(feature) {
		let isAvailable = false;
		const id = feature.properties.id;

		if (this.apartments.hasOwnProperty(id)) {
			const apartment = this.apartments[id];
			isAvailable = apartment.availability === 'available' ? true : false;
		}

		return isAvailable;
	}

	eachFeature(feature, layer) {
		let self = this;

		layer.bindPopup(this.popupTemplate(feature.properties.id.replace('-', '_')), {
			closeButton: false,
			autoPanPadding: [50, 50],
		});

		layer.on({
			mouseover: () => {
				layer.setStyle({
					fillColor: '#5312EB',
					color: '#5312EB',
					fillOpacity: 0.5,
					opacity: 1,
				});

				if (!L.Browser.opera && !L.Browser.edge) {
					layer.bringToFront();
				}
			},
			mouseout: (e) => {
				if (layer.isPopupOpen() === false) {
					self.jsonLayer.resetStyle(e.target);
				}
			},
			click: (e) => {
				if (window.innerWidth > 768) {
					self.map.fitBounds(e.target.getBounds());
				}
			},
			popupopen: (e) => {
				layer.setStyle({
					fillColor: '#5312EB',
					color: '#5312EB',
					fillOpacity: 0.5,
					opacity: 1,
				});
			},
			popupclose: (e) => {
				self.jsonLayer.resetStyle(e.target);
			},
		});
	}

	popupTemplate(id) {
		if (this.apartments.hasOwnProperty(id) === false) {
			return '';
		}

		const placement = this.apartments[id];

		return Mustache.render(this.floorplan.querySelector('#popup-template').innerHTML, placement);
	}
}
